import React from "react";
import { Card, Empty, Spin, Typography } from "antd";
import { BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import moment from "moment";
import { getBandwidthConsumeReport } from "../ducks/services";
import { useKeycloak } from "@react-keycloak/web";
import { LoadingOutlined } from "@ant-design/icons";
const { Title } = Typography;
const antIcon = <LoadingOutlined spin />;

const BandwidthConsumeChart = ({ data = [], loading }) => {
  if (loading) {
    return <Spin indicator={antIcon} />;
  }

  // if (data.length === 0) {
  //   return <Card><Empty description="No bandwidth usage found." /></Card>;
  // }

  const chartData = Array.from(data.values())
    .sort((a, b) => a.date - b.date) // Sort chronologically
    .map(({ label, bandwidth_gb }) => ({
      label,
      bandwidth_gb
    }));

  const yMax = Math.ceil(Math.max(...data.map(d => d.bandwidth_gb), 1) / 10) * 10;

  const formatBandwidth = (v) => {
    if (v >= 1024) {
      return (v / 1024).toFixed(2) + ' TB';
    }
    return v.toFixed(2) + ' GB';
  };
  return (
    <Card
      className="custom-card-graph"
      title={<Title level={3}>Bandwidth</Title>}
      style={{ textAlign: 'left' }}
      bodyStyle={{minHeight: 120, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}
    >
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
          <Spin indicator={antIcon} size="large" />
        </div>
      ) : data.length === 0 ? (
        <Empty description="No bandwidth usage found." />
      ) : (
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={chartData} margin={{ top: 20, right: 30, left: 40, bottom: 80 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis
              dataKey="label"
              tick={{ fontSize: 11 }}
              angle={-30}
              textAnchor="end"
              interval={0}
              height={80}
            />
            <YAxis
              tickFormatter={formatBandwidth}
              domain={[0, yMax]}
              tick={{ fontSize: 11 }}
              width={80}
              label={{
                value: 'Bandwidth',
                angle: -90,
                position: 'insideLeft',
                offset: -10,
                style: { fontWeight: 'bold' }
              }}
            />
            <Tooltip
              formatter={v => formatBandwidth(Number(v))}
              contentStyle={{
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '8px'
              }}
            />
            <Bar dataKey="bandwidth_gb" fill="#377fae" barSize={50} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </Card>
  );
};

export default BandwidthConsumeChart;
